// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-facet-details-tsx": () => import("./../../../src/templates/FacetDetails.tsx" /* webpackChunkName: "component---src-templates-facet-details-tsx" */),
  "component---src-templates-table-view-tsx": () => import("./../../../src/templates/TableView.tsx" /* webpackChunkName: "component---src-templates-table-view-tsx" */)
}

